module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo daterange-field"
  }, [_c('div', {
    staticClass: "py-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('date-range-picker', {
    ref: "picker",
    attrs: {
      "opens": _vm.opens,
      "locale-data": {
        firstDay: 1,
        format: 'yyyy-mm-dd',
        customRangeLabel: 'Custom Range',
      },
      "singleDatePicker": _vm.singleDatePicker,
      "timePicker": _vm.timePicker,
      "timePicker24Hour": _vm.timePicker24Hour,
      "showWeekNumbers": _vm.showWeekNumbers,
      "showDropdowns": _vm.showDropdowns,
      "autoApply": _vm.autoApply,
      "ranges": _vm.show_ranges ? _vm.ranges : false,
      "linkedCalendars": _vm.linkedCalendars,
      "always-show-calendars": false,
      "alwaysShowCalendars": _vm.alwaysShowCalendars
    },
    on: {
      "update": _vm.updateValues,
      "toggle": _vm.checkOpen
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return _c('div', {
          staticStyle: {
            "min-width": "350px"
          }
        }, [_vm._v("\n          " + _vm._s(_vm._f("date")(picker.startDate)) + " - " + _vm._s(_vm._f("date")(picker.endDate)) + "\n        ")])
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('img', {
    staticClass: "calImg",
    attrs: {
      "src": require("../../assets/calender2.png"),
      "alt": "LiveRun"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bda49fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/DateRangeField.vue
// module id = 1846
// module chunks = 1